import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';

export default Vue.component('delete-account', {
  template: require('./template.html'),
  name: 'delete-account',
  mixins: [guid],
  computed: {
    ...mapGetters([
      'websites',
      'currentUser',
    ]),
  },
  data() {
    return {
      loading: false,
      deleteErrors: [],
      typeConfirm: '',
      confirmPassed: false,
      confirmMsg: 'yes cancel services',
      successMsg: false,
      sad: true,
      cursorPos: {
        x: 0,
        y: 0,
      },
      $droplet: null,
      $eyes: null,
    };
  },
  props: ['modal', 'toggle-modal'],
  watch: {
    modal(o) {
      if (o) {
        this.resetModal();
      }
    },
  },
  mounted() {
    this.initSadDroplet();
  },
  destroyed() {
    window.removeEventListener('mousemove', this.moveEyes, false);
  },
  methods: {
    confirm() {
      if (this.typeConfirm === this.confirmMsg) {
        this.confirmPassed = true;
      } else {
        this.confirmPassed = false;
      }
    },
    closeModal(type) {
      this.$emit('toggle-modal', type, 'child');
    },
    resetModal() {
      this.confirmPassed = false;
      this.typeConfirm = '';
      this.deleteErrors = [];
    },
    async cancelAccount() {
      if (this.typeConfirm === this.confirmMsg) {
        // call delete actions
        this.loading = true;
        this.deleteErrors = [];
        try {
          const cancelAccount = await this._SEND([{
            name: 'cancelAccount',
          }]);
          this.$log.info('Successfully cancelled account: ', cancelAccount);
          this.successMsg =
            `You have successfully cancelled your services with Drzzle!
             Although we are sad to see you go, we wish you well in your quest
             to conquer the web!`;
          this.$store.dispatch('setWebsites', { websites: [] });
          const user = this.currentUser;
          this.$store.dispatch('runStateFn', {
            fn() {
              user.subUsers = [];
            },
          });
        } catch (e) {
          this.$log.error('error: ', e);
          this.deleteErrors.push(e);
          await this._reportError({
            error: e,
            fn: 'cancelAccount',
          });
        } finally {
          this.loading = false;
          this._trackEvent({
            type: 'delete_account',
          });
        }
      }
    },
    eyeFollow() {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const getOffset = (el) => {
        let eye = el;
        eye = el.getBoundingClientRect();
        return {
          x: eye.left + window.scrollX,
          y: eye.top + window.scrollY,
        };
      };

      const moveEye = (eye) => {
        const eyeOffset = getOffset(eye);
        const bBox = eye.getBBox();
        const centerX = (eyeOffset.x + bBox.width) / 2;
        const centerY = (eyeOffset.y + bBox.height) / 2;
        const percentTop = Math.round((this.cursorPos.y - centerY) * (100 / windowHeight));
        const percentLeft = Math.round((this.cursorPos.x - centerX) * (100 / windowWidth));
        eye.style.transform = `translate(${percentLeft / 5}px, ${percentTop / 5}px)`;
      };

      return {
        init: (el) => {
          moveEye(el);
        },
      };
    },
    moveEyes(e) {
      this.cursorPos = {
        x: e.clientX,
        y: e.clientY,
      };
      this.eyeFollow().init(this.$eyes);
    },
    initSadDroplet() {
      this.$droplet = this.$refs.sadDroplet;
      this.$eyes = this.$droplet.getElementById('sad_eyes');
      this.eyeFollow();
      window.addEventListener('mousemove', this.moveEyes, false);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/account/billing/delete/index.js